import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from '@/locales/en.json';
import ru from '@/locales/ru.json';
import { LANGUAGE_NAME } from '@/configs/profileConfigs';
import { ELanguages } from '@/types';

Vue.use(VueI18n);

const defaultLang = ELanguages.en.toLocaleLowerCase();
let lang = localStorage.getItem(LANGUAGE_NAME);

if ((lang && !ELanguages[lang]) || !lang) {
  lang = defaultLang;
  localStorage.setItem(LANGUAGE_NAME, defaultLang);
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || lang,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || lang,
  silentTranslationWarn: true,
  messages: { en, ru },
});
